/**
 * @generated SignedSource<<32233d9855a71c898adc6beb8d62e542>>
 * @relayHash d24b4ad1a97ccd24bce6bb96d6c01dac
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2e88bfb638882023f3cc1a09ab0c61a86c228f3bc54710b3f1082519e7e4a32c

var node = function () {
  var v0 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    },
    v1 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "helpCenterAri"
    },
    v2 = [{
      "kind": "Variable",
      "name": "cloudId",
      "variableName": "cloudId"
    }],
    v3 = [{
      "kind": "Variable",
      "name": "helpCenterAri",
      "variableName": "helpCenterAri"
    }],
    v4 = {
      "kind": "InlineFragment",
      "selections": [{
        "concreteType": "HelpCenterBranding",
        "kind": "LinkedField",
        "name": "helpCenterBranding",
        "plural": false,
        "selections": [{
          "concreteType": "HelpCenterBrandingColors",
          "kind": "LinkedField",
          "name": "colors",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "name": "primary"
          }]
        }]
      }],
      "type": "HelpCenter"
    },
    v5 = {
      "kind": "ScalarField",
      "name": "id"
    },
    v6 = {
      "kind": "InlineFragment",
      "selections": [v5 /*: any*/, {
        "kind": "ScalarField",
        "name": "isEnabled"
      }, {
        "kind": "ScalarField",
        "name": "position"
      }, {
        "concreteType": "CsmAiWidgetBrandingTheme",
        "kind": "LinkedField",
        "name": "theme",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "name": "colorVibeVariant"
        }, {
          "kind": "ScalarField",
          "name": "radius"
        }, {
          "kind": "ScalarField",
          "name": "space"
        }, {
          "kind": "ScalarField",
          "name": "chatColor"
        }]
      }],
      "type": "CsmAiWidgetConfig"
    },
    v7 = {
      "kind": "ScalarField",
      "name": "__typename"
    };
  return {
    "fragment": {
      "argumentDefinitions": [v0 /*: any*/, v1 /*: any*/],
      "kind": "Fragment",
      "name": "aiWidgetProviderQuery",
      "selections": [{
        "args": v2 /*: any*/,
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [{
          "args": v3 /*: any*/,
          "kind": "LinkedField",
          "name": "helpCenterById",
          "plural": false,
          "selections": [v4 /*: any*/]
        }]
      }, {
        "args": v3 /*: any*/,
        "kind": "LinkedField",
        "name": "csmAi_getSupportWidget",
        "plural": false,
        "selections": [v6 /*: any*/]
      }],
      "type": "Query"
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [v1 /*: any*/, v0 /*: any*/],
      "kind": "Operation",
      "name": "aiWidgetProviderQuery",
      "selections": [{
        "args": v2 /*: any*/,
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [{
          "args": v3 /*: any*/,
          "kind": "LinkedField",
          "name": "helpCenterById",
          "plural": false,
          "selections": [v7 /*: any*/, v4 /*: any*/, {
            "kind": "InlineFragment",
            "selections": [v5 /*: any*/],
            "type": "Node",
            "abstractKey": "__isNode"
          }]
        }]
      }, {
        "args": v3 /*: any*/,
        "kind": "LinkedField",
        "name": "csmAi_getSupportWidget",
        "plural": false,
        "selections": [v7 /*: any*/, v6 /*: any*/]
      }]
    },
    "params": {
      "id": "2e88bfb638882023f3cc1a09ab0c61a86c228f3bc54710b3f1082519e7e4a32c",
      "metadata": {},
      "name": "aiWidgetProviderQuery",
      "operationKind": "query",
      "text": null
    }
  };
}();
node.hash = "cc0a8c3c2e0c2ac2a4e32f0440175bfe";
export default node;